<template>
  <div class="notfound" v-wechat-title="$t($route.meta.title) + ' - ' + $t('app.name')">
    <NavHome class="aboutNav" style="padding:18px 0 15px" v-once/>
    <div class="results">
      <div class="shadow-divide"></div>
      <div class="results-wrap">
        <div class="results-wrap-content">
          <img src="@/assets/images/404.png" class="slogo-img">
          <p class="msg">{{$t('notfoundMsg')}}</p>
          <a href="/" class="back">{{$t('btn.backHome')}}</a>
        </div>
      </div>
    </div>
    <Footer style="padding: 30px 0 15px;background-color: #fff;" />
  </div>
</template>

<script>
import NavHome from './NavHome'
import Footer from './Footer'

export default {
  name: 'NotFound',
  components: { NavHome, Footer },
  mounted () {
    this.$nextTick(() => {
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      resultDom.style.minHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getRealElSize(footer).height - 18)) + 'px'
    })
  }
}
</script>
<style scoped>
  .results{
    position: relative;
    padding: 15px 0 5px;
    background-color: #ecf5fe;
    text-align: center;
  }
  .results-wrap{
    width:1400px;
    margin: 0 auto;
    padding-bottom: 20px;
    max-width: 960px;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .notfound >>> footer .wrap{
    width:1400px;
    padding-right: 17.5px;
  }
  .results-wrap-content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .slogo-img{
    width: 250px;
  }
  .msg{
    color: #333;
    margin: 25px 0 20px;
    font-size: 14px;
  }
  a.back{
    border: 0.5px solid #869fb3;
    height: 28px;
    line-height: 26px;
    width: 90px;
    text-align: center;
    display: block;
    margin: 0 auto;
    font-size: 14px;
  }
  a.back,
  a.back:hover{
    text-decoration: none;
    box-shadow: none;
    color: #7ea9c9;
    padding: 0;
  }
  a.back:after{
    width: 0;
    height: 0;
    content: none;
  }
</style>




// WEBPACK FOOTER //
// src/components/layout/NotFound.vue